'use client';
import { Empty, Input, Spin } from 'antd';
import styles from './chat.module.scss';
import { CiSearch } from 'react-icons/ci';
import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'context';
import { ChatType, PaginationType, ResponseType, ThemeEnum } from 'types';
import { COLORS } from 'utilities';
import ChatCardComp from './chatCard/chatCard.index';
import { RestAPI, useBP } from 'scripts';
import ChatMessageDetailComp from './chatMessageDetail/chatMessageDetail.index';
import { API } from 'data';
import { useSearchParams } from 'react-router-dom';

function ChatComp() {
    const { theme } = useContext(GlobalContext);
    const [searchParams, setSearchParams] = useSearchParams();
    const [showList, setShowList] = useState<'sent' | 'received'>('sent');
    const [chatListData, setChatListData] = useState<ResponseType<PaginationType<ChatType>>>();
    const [search, setSearch] = useState('');
    const bp = useBP()?.MD_LTE;
    const activeChat = chatListData?.data.data.find((i) => i.id.toString() === searchParams.get('chat'));

    useEffect(() => {
        setChatListData(undefined);
        getChatListData();
        const temp = setInterval(getChatListData, 20 * 1000);
        return () => {
            clearInterval(temp);
        };
    }, [showList]);

    function getChatListData() {
        RestAPI.get<PaginationType<ChatType>>(showList === 'received' ? API.chat.receivedList : API.chat.sentList, {
            page: 1,
            page_size: 100,
        })
            .then(setChatListData)
            .catch(setChatListData);
    }
    useEffect(() => {
        if (chatListData && activeChat) {
            const list = [...chatListData.data.data];
            const index = list.findIndex((i) => i.id === activeChat.id);
            if (list[index].unread_messages) {
                list[index] = { ...list[index], unread_messages: 0 };
                const temp = { ...chatListData };
                temp.data.data = list;
                setChatListData(temp);
            }
        }
    }, [chatListData, searchParams]);

    if (!chatListData)
        return (
            <div className={`w-100 pv-9 center-content flex-1`}>
                <Spin />
            </div>
        );

    return (
        <div className={`${styles['chat-layout']} d-flex`}>
            <div className={`${styles['chat-list']} flex-1 ${activeChat && bp ? 'd-none' : ''}`}>
                <div className={`${styles['header-chat-list']} mb-2`}>
                    <div className="center-content-y g-1 mb-2-i">
                        <Input
                            placeholder={showList === 'sent' ? 'جستجو در همه آگهی ها' : 'حست و جو در همه کاربران'}
                            className={`${styles['search-input']} w-100`}
                            onChange={(e) => setSearch(e.target.value)}
                            value={search}
                            prefix={
                                <CiSearch
                                    size={20}
                                    color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray2}
                                    className={`${styles['search-icon']}`}
                                />
                            }
                        />
                    </div>
                    <div className="d-flex g-1 center-content-y">
                        <div
                            className={`${styles['link-box']} ${showList === 'received' ? styles['active'] : ''} center-content p-1 pointer`}
                            onClick={() => {
                                if (showList === 'sent' && activeChat) setSearchParams({});
                                setShowList('received');
                            }}
                        >
                            <p className="t-p3 t-400 t-l-gray1">آگهی های من</p>
                        </div>
                        <div
                            className={`${styles['link-box']} ${showList === 'sent' ? styles['active'] : ''} center-content p-1 pointer`}
                            onClick={() => {
                                if (showList === 'received' && activeChat) setSearchParams({});
                                setShowList('sent');
                            }}
                        >
                            <p className="t-p3 t-400 t-l-gray1">آگهی های دیگران</p>
                        </div>
                    </div>
                </div>
                <div className={`${styles['message-list']}`}>
                    {!chatListData ? (
                        <div className={`w-100 pv-9 center-content flex-1`}>
                            <Spin />
                        </div>
                    ) : (
                        <>
                            {chatListData?.data.data.filter((i) => {
                                if (showList === 'sent') return i.post.title.includes(search);
                                else return (i.user.first_name + ' ' + i.user.last_name).includes(search);
                            }).length ? (
                                chatListData.data.data
                                    .sort((a, b) => {
                                        const date_a = a.last_message?.created_at ?? a.created_at;
                                        const date_b = b.last_message?.created_at ?? b.created_at;
                                        return new Date(date_b).getTime() - new Date(date_a).getTime();
                                    })
                                    .map((item, index) => (
                                        <ChatCardComp
                                            key={index}
                                            data={item}
                                            className="mb-2"
                                            onClick={() => {
                                                setSearchParams({ chat: item.id.toString() });
                                            }}
                                        />
                                    ))
                            ) : (
                                <Empty
                                    className="w-100 center-content-i mt-3-i"
                                    description={
                                        <p className="t-p2 t-l-gray1 t-400 text-center">تا کنون چتی نداشته اید</p>
                                    }
                                />
                            )}
                        </>
                    )}
                </div>
            </div>
            <div className={`${styles['chat-detail']} flex-1 ${!activeChat && bp ? 'd-none' : ''}`}>
                {activeChat ? (
                    <ChatMessageDetailComp
                        onBack={() => setSearchParams({})}
                        data={activeChat}
                        mode={showList}
                        onReport={() => {
                            if (chatListData) {
                                const newList = { ...chatListData };
                                const index = newList.data?.data.findIndex((i) => i.id === activeChat.id);
                                if (newList.data?.data.length && index !== undefined && index >= 0) {
                                    newList.data.data[index] = {
                                        ...newList.data.data[index],
                                        is_reported: "I've reported",
                                    };
                                }
                                setChatListData(newList);
                            }
                            // if (activeChat) setActiveChat({ ...activeChat, is_reported: "I've reported" });
                        }}
                        onSent={(e) => {
                            if (chatListData) {
                                const newList = { ...chatListData };
                                const index = newList.data?.data.findIndex((i) => i.id === activeChat.id);
                                if (newList.data?.data.length && index !== undefined && index >= 0) {
                                    newList.data.data[index] = { ...newList.data.data[index], last_message: e };
                                }
                                setChatListData(newList);
                            }
                        }}
                    />
                ) : (
                    <Empty
                        className="w-100 center-content-i mt-3-i mh-0"
                        description={
                            <p className="t-p2 t-l-gray1 t-400 text-center">لطفا یک مورد برای چت انتخاب نمایید</p>
                        }
                    />
                )}
            </div>
        </div>
    );
}

export default ChatComp;
